import classNames from 'classnames'

import { ProfileUsersWidgetItem } from '../../../../../Widget'
import { getIsApplicantDecisionUserIconsShown } from '../ApplicantDecisionPanel.utils'

import * as styles from '../ApplicantDecisionPanel.module.css'

function ApplicantDecisionUser({ avatarSize, isMuted, qaName, value }) {
  const itemProps = {
    AdditionalInfo: null,
    avatarSize,
    hoverClassName: null,
    isArchived: Boolean(value?.archived),
    isNeedToShowIcons: getIsApplicantDecisionUserIconsShown,
    textQaName: qaName,
    value,
  }

  return (
    <span className={classNames(styles.user, { [styles.mutedUser]: isMuted })}>
      {/* TODO: mock applicants carry mock users, so the user is not a link until they are served */}
      <ProfileUsersWidgetItem {...itemProps} blocked />
    </span>
  )
}

export default ApplicantDecisionUser
